import http, { HttpBodyUnpacking } from '@/lib/request.js'

import * as container from '@/lib/container.js'
import * as detective from '@/lib/detective.js'
import * as structure from '@/lib/structure.js'

import * as contract_model from '@/model/contract.js'

import type * as archive from './archive.js'




export type TRawDocumentType = Required<contract_model.THydratedDocumentType>

export type THydratedDocumentType
<
	T extends keyof contract_model.TPopulatePaths = 'user' | 'company' | 'archive',

>
	= structure.Overwrite<
		contract_model.THydratedDocumentType,

		Pick<contract_model.TPopulatePaths, T>

	>


export function create_agreement
(_id: string): HttpBodyUnpacking<string>
{
	return http.post(`/contract/${_id}/agreement`)

}


export function update
(
	_id: string,

	data: Partial< Omit<contract_model.THydratedDocumentType, '_id' | 'weapp' | 'user'> >,

)
:	HttpBodyUnpacking<void>
{
	return http.put(`/contract/${_id}`, data)

}


export function retrieve
(_id: string): HttpBodyUnpacking<TRawDocumentType>
{
	return http.get(`/contract/${_id}`)

}

export function retrieve_archive
(_id: string): HttpBodyUnpacking<archive.THydratedDocumentType>
{
	return http.get(`/contract/${_id}/archive`)

}

export function retrieves
(
	params: container.PagerParams<
		{
			keyword?: string

			begin? : null | detective.Range<Date>
			finish?: null | detective.Range<Date>

			resigned?: null | detective.Range<Date>

			sign?      : string
			settle?    : string
			office?    : string
			insurance? : string
			enrollment?: Date

			example?: boolean

		}

	>,

)
:	HttpBodyUnpacking<THydratedDocumentType[]>
{
	return http.get('/contracts', { params })

}


export function delete_
(_id: string): HttpBodyUnpacking<void>
{
	return http.delete(`/contract/${_id}`)

}
